import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import falist from './../../../../assets/fa/falist.json';

export interface FaIcon {
  icon: string;
  color: string;
}

export interface FaIconRaw {
  name: string;
  unicode: string;
  path: string;
}

@Component({
  selector: 'fa-icons',
  templateUrl: './fa-icons.component.html',
  styleUrls: ['./fa-icons.component.scss']
})
export class FaIconsComponent implements OnInit {

  active: number = 1;
  
  search: string = '';

  icon: string = '';

  @Input()
  color: string = '#6c757d';

  SOLID: FaIconRaw[] = [];
  REGULAR: FaIconRaw[] = [];
  LIGHT: FaIconRaw[] = [];
  DUOTONE: FaIconRaw[] = [];
  BRANDS: FaIconRaw[] = [];
  filteredSOLID: FaIconRaw[] = [];
  filteredREGULAR: FaIconRaw[] = [];
  filteredLIGHT: FaIconRaw[] = [];
  filteredDUOTONE: FaIconRaw[] = [];
  filteredBRANDS: FaIconRaw[] = [];

  constructor() { }
  
  @Output() 
  public selectionComplete: EventEmitter<any> = new EventEmitter<any>(); //Event for selection complete
    
  @Output() 
  public uploadIcon: EventEmitter<any> = new EventEmitter<any>(); //Event for selection complete

  ngOnInit(): void {
    this.SOLID = this.loadIcons('solid');
    this.REGULAR = this.loadIcons('regular');
    this.LIGHT = this.loadIcons('light');
    this.DUOTONE = this.loadIcons('duotone');
    this.BRANDS = this.loadIcons('brands');
    this.filteredSOLID = this.SOLID;
    this.filteredREGULAR = this.REGULAR;
    this.filteredLIGHT = this.LIGHT;
    this.filteredDUOTONE = this.DUOTONE;
    this.filteredBRANDS = this.BRANDS;
  }


  /**
   * Load icons from generated JSON of fa icons depending on given fa_type (solid, regular, light, duotone, brands)
   * @param fa_type 
   * @returns 
   */
  loadIcons(fa_type: string): FaIconRaw[] {
    let fa: FaIconRaw[] = [];
    switch (fa_type) {
      case 'solid':
        fa = falist.solid as FaIconRaw[];
        break;
      case 'regular':
        fa = falist.regular as FaIconRaw[];
        break;
      case 'light':
        fa = falist.light as FaIconRaw[];
        break;
      case 'duotone':
        fa = falist.duotone as any[];
        fa.forEach((f: any) => {
          f.path = f.path.toString();
        });
        fa = fa as FaIconRaw[];
        break;
      case 'brands':
        fa = falist.brands as FaIconRaw[];
        break;
    }
    return fa;
  }

  /**
   * Search among icons
   */
  searchIcons(): void {
    if (this.search === '') {
      this.resetIcons();
    } else {
      this.filteredSOLID = this.SOLID.filter(i => i?.name?.toLowerCase().includes(this.search.toLowerCase()));
      this.filteredREGULAR = this.REGULAR.filter(i => i?.name?.toLowerCase().includes(this.search.toLowerCase()));
      this.filteredLIGHT = this.LIGHT.filter(i => i?.name?.toLowerCase().includes(this.search.toLowerCase()));
      this.filteredDUOTONE = this.DUOTONE.filter(i => i?.name?.toLowerCase().includes(this.search.toLowerCase()));
      this.filteredBRANDS = this.BRANDS.filter(i => i?.name?.toLowerCase().includes(this.search.toLowerCase()));
    }
  }

  /**
   * Handle selection icon event
   * output event selectionComplete
   * @param faRaw 
   */
  selectIcon(faRaw: string): void {
    const faIcon: FaIcon = {
      icon: faRaw,
      color: this.color
    }
    this.selectionComplete.emit(faIcon);
    this.search = '';
    this.resetIcons();
  }

  /**
   * Reset icons search to original list
   */
  resetIcons(): void {    
    this.filteredSOLID = this.SOLID;
    this.filteredREGULAR = this.REGULAR;
    this.filteredLIGHT = this.LIGHT;
    this.filteredDUOTONE = this.DUOTONE;
    this.filteredBRANDS = this.BRANDS;
  }
}